{
  "ReservationTableConfig": {
    "columns": [
       {
        "fieldName": "customer.name",
        "displayName": "Customer Name",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "100px"
        }     
      },
      {
        "fieldName": "reservedVolume",
        "displayName": "Reserved Volume (sq mt)",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "60px"
        },
        "styleConfig": {
          "type": "badge",
          "conditions": [
            {
              "expression": "eq(value, undefined)",
              "styleProperties": {
                "display": "none"
              }
            }
          ],
          "styleProperties": {
            "width": "100px",
            "display": "flex",
            "align-items": "center",
            "border-radius": "6px",
            "border": "1px solid #D0D5DD",
            "background": "var(--Gray-100, #F2F4F7)",
            "box-shadow": "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
            "color": "var(--Gray-700, #344054)",
            "text-align": "center",
            "font-family": "Inter",
            "font-size": "12px",
            "font-style": "normal",
            "font-weight": "500",
            "line-height": "18px"
          }
        }
      },

      {
        "fieldName": "fromDate",
        "displayName": "From",
        "dataType": "DATETIME",
          "thStyleConfig": {
          "width": "60px"
        }
      },
      {
        "fieldName": "toDate",
        "displayName": "To",
        "dataType": "DATETIME",
          "thStyleConfig": {
          "width": "60px"
        }
      }
    ]    
    },
  "filterConfig": {
    "filterFields": [
      {
        "name": "NAME_CONTAINS",
        "displayLabel": "Name",
        "dataType": "STRING",
        "operatorToFilterMap": {
          "CONTAINS": "NAME_CONTAINS"
        }
      },
  
      {
        "name": "ACTIVE_EQUALS",
        "displayLabel": "Active",
        "dataType": "BOOLEAN",
        "operatorToFilterMap": {
          "EQ": "ACTIVE_EQUALS"
        }
      }
    
    ],
    "useNewContract": true
  },
  
  "searchBarConfig": {
    "placeHolder": "Search Warehouse by name",
    "filters": [
      {
        "name": "NAME_CONTAINS",
        "alias": "warehouse_name"
      }
    ]
  },

  "containerColumnMeta": [
        {
            "displayLabel": "Warehouse Name",
            "fieldName": "name"
        },
        {
            "displayLabel": "Total Area (sq.mt)",
            "fieldName": "totalVolume"
        },
        {
            "displayLabel": "Reserved Area (sq.mt)",
            "fieldName": "reservedVolume"
        }
    ]
}
